export const ActionCommands = {
  QC_CHECK: "QC_CHECK",

  ///TPS commands
  LOCK_DEVICE: "LOCK_DEVICE",
  UNLOCK_DEVICE: "UNLOCK_DEVICE",
  EXIT_LAUNCHER: "EXIT_LAUNCHER",
  CAPTURE_TA_LOG: "CAPTURE_TA_LOG",

  ///TA commands
  ONE_CLICK: "run_1_click",
};

export const PROJECTS = {
  TA: "TA",
  TPS: "TPS",
};

/// TODO all the logics for Parameters
export const QC_VALIDATIONS = [
  {
    id: "DEVICE_MODEL_VALIDATION",
    displayTitle: "Model Check",
    title: "Checking model version",
    message:
      "<div>Validating hardware model<br /> Expected model: <b>$expected</b>.<br /> Detected Device model: <b>$detected</b></div>",
    priority: 0,
    params: {
      device_model: "Lenovo TB-7305X",
    },
    status: null,
    skippable: true,
  },
  {
    id: "FIRMWARE_VALIDATION",
    displayTitle: "Firmware Check",
    title: "Checking if firmware is Good",
    message:
      "<div>Validating the firmware version, found: <b>$detected</ b> version which is <b>$recommended</b>.</div>",
    priority: 0,
    params: {
      bad_firmware_versions: [
        "TB-7305X_S000126_220620_ROW",
        "TB-7306F_S000040_220329_ROW",
        "TB-7306F_S000041_220525_ROW",
        "TB-7306X_S000047_220411_ROW",
        "TB-7306X_S000049_220615_ROW",
        "TB-7306X_S000051_220909_ROW",
        "TB-7306X_S000052_221104_ROW",
        "TB-7306X_S000053_221226_ROW",
        "TB-7306X_S000055_230412_ROW",
        "TB-8505F_S320019_220720_BMP",
        "TB-8505F_S300907_230331_BMP",
      ],
    },
    status: null,
    skippable: true,
  },
  {
    id: "CONFIGURATION_VALIDATION",
    displayTitle: "Config Check",
    title: "TPS Configuration Validation",
    message:
      "<div>Validating TPS configuration <br /> Expected configuration: <b>$expected</b>.<br /> Detected configuration: <b>$detected</b>.</div>",
    priority: 0,
    params: {
      configuration_id: 17,
      configuration_name: "Default M7",
    },
    status: null,
    skippable: true,
  },
  {
    id: "GROUP_ID_VALIDATION",
    displayTitle: "Enrollment Check",
    title: "School Enrollment Validation",
    message:
      "<div>Validating device enrollment <br /> Expected Group Id: <b>$expected</b>. <br /> Detected GroupId is: <b>$detected</b>.</div>",
    priority: 0,
    params: {
      group_id: 1,
      school_id: 1,
      school_name: null,
    },
    status: null,
    skippable: true,
  },
  {
    id: "APP_INSTALLATION_CHECK",
    displayTitle: "Apps Check",
    title: "Verifying Required App Installation",
    message:
      "<div>Validating the installation status of required apps based on TPS configurations. Status: <b>$detected</b>.</div>",
    priority: 0,
    params: {
      required_packages: [],
    },
    status: null,
    skippable: true,
  },
  {
    id: "SD_CARD_SIZE_VALIDATION",
    displayTitle: "SD Size Check",
    title: "SD Card Size Validation",
    message:
      "<div>Validating SD Card size <br /> Expected: <b>$expected</b>.<br /> Detected size <b>$detected</b>.</div>",
    priority: 0,
    params: {
      sd_card_size: 65536,
    },
    status: null,
    skippable: true,
  },
  {
    id: "WRITE_TO_SD_CARD",
    displayTitle: "SD Writable?",
    title: "is SD Card Writable?",
    message:
      "<div>Validating is SD Card Writable?. which is <b>$status</b>.</div>",
    priority: 0,
    params: {},
    status: null,
    skippable: true,
  },
  {
    id: "READ_SD_CARD",
    displayTitle: "SD Readable?",
    title: "is SD Card Readable?",
    message:
      "<div>Validating is SD Card Readable. which is <b>$status</b>.</div>",
    priority: 0,
    params: {},
    status: null,
    skippable: true,
  },
  {
    id: "SD_CARD_PROFILE_VALIDATION",
    displayTitle: "SD Profile Check",
    title: "SD Card Profile Validation",
    message: `<div>Validating SD Card Profile  <br /> Expected Profile: <b>$expected</b>.<br /> Detected Profile: <b>$detected</b>.
    <br /> SD card QC State is <b>$qcresult</b> <br /> Red Resources count: <b>$red_resources</b>.</div>`,
    priority: 0,
    params: {
      profile_name: null,
      yaml_path: null,
      product_type: null,
    },
    status: null,
    skippable: true,
  },
  {
    id: "LOGIN_TO_TA_APP",
    displayTitle: "Content Check",
    title: "Content Validation in TA",
    message: `<div>Validating Content in TA <br /> App Version: <b>$app_version</b>. <br />OneClick Status: <b>$oneclick_status</b>.
    <br /> Error message: <b>$message</b>. <br /> Red Resources count: <b>$red_resources</b>.</div>`,
    priority: 0,
    params: {
      login_id: "9988223371",
      password: "FuncByPass",
      isAutoOneClickEnabled: false,
      executionTime: 10800000,
      wareHouseTesting: false,
      isClearDataEnabled: false,
      package_name: null,
    },
    status: null,
    skippable: true,
  },
  {
    id: "DISPLAY_MESSAGE",
    displayTitle: "Overall Device Status",
    title: "Overall Device Status",
    message: `<div>Device certification <b>$status</b></div>`,
    priority: 0,
    hide: true,
    status: null,
    skippable: true,
  },
];

export const STATUSCOLORMAP = {
  Success: "green",
  Failed: "red",
  Paused: "orange",
  TimeOut: "grey",
  null: "grey",
};

export const CARDS = [
  {
    id: 1,
    title: ActionCommands.LOCK_DEVICE,
    description: "Triggering this will Lock the device",
    project: PROJECTS.TPS,
    triggerName: ActionCommands.LOCK_DEVICE,
    enabled: true,
  },
  {
    id: 2,
    title: ActionCommands.UNLOCK_DEVICE,
    description: "Triggering this will UnLock the device",
    project: PROJECTS.TPS,
    triggerName: ActionCommands.UNLOCK_DEVICE,
    enabled: true,
  },
  {
    id: 3,
    title: ActionCommands.EXIT_LAUNCHER,
    description: "This will Remove TPS Temporary",
    project: PROJECTS.TPS,
    triggerName: ActionCommands.EXIT_LAUNCHER,
    enabled: true,
  },
  {
    id: 4,
    title: ActionCommands.ONE_CLICK,
    description: "This will do one click for device",
    project: PROJECTS.TA,
    triggerName: ActionCommands.ONE_CLICK,
    enabled: false,
  },
  {
    id: 5,
    title: ActionCommands.CAPTURE_TA_LOG,
    description: "Will upload TA logs file to s3",
    project: PROJECTS.TPS,
    triggerName: ActionCommands.CAPTURE_TA_LOG,
    enabled: true,
  },
].filter((item) => item.enabled);
